import React, { Component } from "react";
const classes = require('./Accordion.module.scss');

class Accordion extends Component {  
  render() {
    const accContent = this.props.accItems.map((accItem) =>
      <li key={accItem.id} className={accItem.open}>
        <button className={["uk-accordion-title", classes.custTitle].join(' ')}>{accItem.title}</button>
        <div className={["uk-accordion-content", classes.custContent].join(' ')}>
          {accItem.content}
        </div>
      </li> 
    );

    return(
      <div className={[classes.Accordion, classes[this.props.altClass], classes[this.props.altClass2], this.props.Shade].join(' ')}>
        <ul className={classes["ul" + this.props.altClass]} data-uk-accordion>
          {accContent}
        </ul>        
      </div>
    )
  }
};
Accordion.defaultProps = {
  Shade: "uk-dark"
};

export default Accordion;